import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ChangeRequestList } from './ChangeRequests/ChangeRequestList';

/** Trang quản lý Change Request (route /change-requests). */
export function ChangeRequests(): JSX.Element {
  return (
    <Box>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Yêu cầu thay đổi
      </Typography>
      <ChangeRequestList />
    </Box>
  );
}
